module.exports = __webpack_public_path__ + "static/media/GT-Alpina-Regular.008daf54.ttf";